import React, { useState } from 'react';
import { loginRequest } from '../AppSettings/routes/config/authConfig';
import './LoginPage.css'; // Import the new styling
import { FaMicrosoft } from 'react-icons/fa';
import useMsalInstance from '../AppSettings/hooks/useMsalInstance';

// SEPT Software Login Page Component
const LoginPage: React.FC = () => {
  const instance = useMsalInstance();

  // State for managing user feedback messages (replaces the old messageBox div)
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<string | null>(null);

  // Function to display messages in the UI
  const showMessage = (msg: string, type: string): void => {
    setMessage(msg);
    setMessageType(type);
    // Clear message after 5 seconds
    setTimeout(() => {
      setMessage(null);
      setMessageType(null);
    }, 5000);
  };

  // Determine CSS classes for the message box based on type
  const getMessageClasses = (): string => {
    if (!message) return 'message-alert d-none';

    let baseClasses = 'message-alert';
    switch (messageType) {
      case 'error':
        return `${baseClasses} alert-error`;
      case 'success':
        return `${baseClasses} alert-success`;
      case 'warning':
        return `${baseClasses} alert-warning`;
      case 'info':
      default:
        return `${baseClasses} alert-info`;
    }
  };

  // Handles the login process using MSAL
  const handleLogin = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault(); // Prevent default form submission

    try {
      showMessage('Redirecting to Microsoft for authentication...', 'info');
      instance.loginRedirect(loginRequest);
    } catch (error) {
      showMessage('An error occurred during login. Please try again.', 'error');
    }
  };

  return (
    <div className="login-page">
      {/* Main Content Area: Centered Login Card */}
      <div className="login-container">
        <div className="login-card">
          {/* Header Section */}
          <div className="login-header">
            <h1 className="login-title">SEPT Software</h1>
            <p className="login-subtitle">
              Secure. Simple. Software that stays out of your way.
            </p>
          </div>

          {/* Login Section */}
          <div className="login-body">
            <h2 className="login-section-title">Single Sign-On (SSO)</h2>

            <p className="login-description">
              Click below to sign in using your existing Microsoft credentials.
              You will be redirected to the Microsoft login page.
            </p>

            <form className="login-form" onSubmit={handleLogin}>
              {/* Message Box for Feedback */}
              <div className={getMessageClasses()} role="alert">
                {message}
              </div>

              {/* Action Button: Microsoft SSO */}
              <button type="submit" className="login-button">
                {/* Inline SVG for Microsoft Logo */}
                <FaMicrosoft></FaMicrosoft>
                <span>Sign In with Microsoft</span>
              </button>

              {/* Simplified Footer Note */}
              <div className="login-footer-note">
                If you experience issues, please contact support.
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="login-page-footer">
        <p className="footer-text">
          &copy; 2024 SEPT Software. All rights reserved.
        </p>
        <p className="footer-text">Built with precision and care.</p>
      </footer>
    </div>
  );
};

export default LoginPage;
